// extracted by mini-css-extract-plugin
module.exports = {"container":"PageLayout-module--container--3260U","content":"PageLayout-module--content--28NF4","isFullWidth":"PageLayout-module--is-full-width--TSFIb"};